/**
 * Social / UGC hosts that should not be SEO compare targets. Keep in sync with
 * backend/src/utils/non-competitor-domains.ts
 */
export const NON_COMPETITOR_DOMAINS: readonly string[] = [
  'facebook.com',
  'instagram.com',
  'twitter.com',
  'x.com',
  'linkedin.com',
  'pinterest.com',
  'tiktok.com',
  'snapchat.com',
  'threads.net',
  'tumblr.com',
  'mastodon.social',
  'bsky.app',
  'youtube.com',
  'youtu.be',
  'vimeo.com',
  'dailymotion.com',
  'reddit.com',
  'quora.com',
  'medium.com',
  'wikipedia.org',
  'wikihow.com',
  'yelp.com'
];

function normalizeHost(value: string): string {
  return (value || '')
    .toLowerCase()
    .trim()
    .replace(/^https?:\/\//, '')
    .replace(/^www\./, '')
    .split('/')[0];
}

/** True when domain is (or is a subdomain of) a non-competitor platform. */
export function isNonCompetitorDomain(domain: string): boolean {
  const host = normalizeHost(domain);
  if (!host) return false;
  return NON_COMPETITOR_DOMAINS.some((base) => host === base || host.endsWith(`.${base}`));
}
